import React, { useContext } from 'react'
import { NotificationContext } from './router'

import CrossIcon from './svg/cross'

// This component is used by almost all queries to create a toast message with a message if the query errors.
// It can also be used to create toast confirmation messages by passing confirmation-message as the type.
const PushNotification = () => {

  const {notification, setNotification} = useContext(NotificationContext);;
  
  return (
    notification && notification.message ? 
        <div className={`push-notification ${ notification.type ? notification.type : 'error-message' }`} role="alert">
            <div className="push-notification__content">
                <p>
                    { notification.message }
                    { notification.error_message ?
                    <em>Error: { notification.error_message }</em>
                    : null }
                </p>
            </div>

            <button type="button" className="btn--cross" onClick={() => { setNotification(null) }} >
                <span className="sr-text">Close alert</span>
                <CrossIcon />
            </button>
        </div>
    : null
  )
}

export { PushNotification };